import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { alpha, styled } from '@mui/material/styles';
import { grey , blue} from '@mui/material/colors';
import { Grid, Avatar, TextField, Switch} from '@mui/material';

import ColorPicker, { useColorPicker } from 'react-best-gradient-color-picker'

import LoadingButton from '@mui/lab/LoadingButton';

import CmsContext from '../../../../store/cms-context';



const CustomSwitch = styled(Switch)(({ theme }) => ({

  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        color:blue[800]
      }
    },
    '&:hover': {
      backgroundColor: alpha(blue[600], theme.palette.action.hoverOpacity),
    }
  },
  '& .MuiSwitch-thumb': {
    color:grey[200]
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: blue[300],
        opacity: 1,
        border: 0,
  },
  
}));

function ProductsColorsDialog(props) {

  console.log("shipping dialog rendered")

  const cmsContext = React.useContext(CmsContext);

  const dropzoneRef = React.useRef(null);

  const [color, setColor] = React.useState('rgba(0,0,255,1)');

  const { valueToHSL, valueToHSV, valueToHex, valueToCmyk, rgbaArr, hslArr } = useColorPicker(color, setColor);

  const colorPickerRef = React.useRef(null);

  const [colorPickerWidth, setColorPickerWidth] = React.useState(null); // Default fallback width


  console.log("color value was: ", color)

  React.useEffect(() => {

    if(props.products_colors_dialog_state.product_color.hex_code && props.products_colors_dialog_state.product_color.hex_code.trim().length > 0){

      setColor(`rgba(${props.products_colors_dialog_state.product_color.red},${props.products_colors_dialog_state.product_color.green},${props.products_colors_dialog_state.product_color.blue},1)`)

    }

  },[props.products_colors_dialog_state])


  React.useEffect(() => {

    if(props.products_colors_dialog_state && props.products_colors_dialog_state.is_dialog_open && !colorPickerRef.current){

    const interval = setInterval(() => {

      console.log("Checking ref:", colorPickerRef.current);

      if (colorPickerRef.current) {

        console.log("Ref is now available:", colorPickerRef.current);
  
        setColorPickerWidth(colorPickerRef.current.offsetWidth * 0.96);
  
        clearInterval(interval); // 🛑 Stop checking once found
      }

    }, 100); // Check every 100ms
  
    return () => clearInterval(interval); // Cleanup if component unmounts

  }

  }, [props.products_colors_dialog_state]);


  console.log("color picker ref 1 was: ", colorPickerRef)


  function set_product_color_state(key, value) {
    
    const temp_state = {...props.products_colors_dialog_state}

    temp_state.product_color[key] = value

    props.set_products_colors_dialog_state(temp_state)
    
  }



  const onSelect = (index, checked) => {

    const temp_variant_image = {...props.selected_variant_image}

    if(checked){
      temp_variant_image.image_index = index
    }else{
      temp_variant_image.image_index = -1
    }

    props.set_selected_variant_image(temp_variant_image)
    
  }



  function handle_product_color() {

    const product_color = {...props.products_colors_dialog_state.product_color}

    console.log("product color was: ", product_color)

    const rgbArr = rgbaArr;

    const hex_value = valueToHex();

    if(!(product_color.name && product_color.name.trim().length > 0)){

      cmsContext.setSnackBarOpen(true, "error", "Please enter a valid color name!")
      return

    }

    if(!rgbArr){

      cmsContext.setSnackBarOpen(true, "error", "Please enter a valid RGB value!")
      return

    }

    if(!hex_value){

      cmsContext.setSnackBarOpen(true, "error", "Please enter a valid Hex value!")
      return

    }

    console.log("product color was: ", product_color)

    const request_body = {hex_code: hex_value, red: rgbArr[0], green: rgbArr[1], blue: rgbArr[2], name: product_color.name}

    console.log("request body was: ", request_body)


    props.post_product_color(request_body, props.products_colors_dialog_state.type)

  }



  function handle_close(){

    const temp_state = {...props.products_colors_dialog_state}

    temp_state.is_dialog_open = false

    props.set_products_colors_dialog_state(temp_state)

  }


  console.log('color picker width was: ', colorPickerWidth)

  return (

    <div>

      <Dialog
        open={props.products_colors_dialog_state.is_dialog_open}
        onClose={handle_close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
         {props.products_colors_dialog_state.type} Product Color
        </DialogTitle>

        <DialogContent dividers>


          <Grid
            container
            spacing={3}
            alignItems="center"
            >

             <Grid
              item
              xs={12}
             
              >

                <Avatar

                    sx={{
                        height: 120,
                        width: 120,
                        ml: 'auto',
                        mr:'auto'
                    }}
                    src="/static/images/splash.png"
                    >

                </Avatar>
                
              </Grid> 


              <Grid
              item
              xs={12}
              style={{marginTop:16}}
              >

                <TextField id="outlined-basic" disabled={props.products_colors_dialog_state.type === "Update"} placeholder='e.g. Blue' label="Name" variant="outlined" value={props.products_colors_dialog_state.product_color.name} onChange={(event)=>{set_product_color_state("name", event.target.value);}} InputLabelProps={{ shrink: true }} fullWidth/>

              </Grid>

              <Grid
              item
              xs={12}
              ref={colorPickerRef}
              >

                <ColorPicker width={colorPickerWidth ? colorPickerWidth : 400} value={color} onChange={(event) => {

                  console.log("setting color target value was: ", event)

                  setColor(event)

                }} hideControls={true} />
                
              </Grid>

            </Grid>
            
        </DialogContent>
        <DialogActions>
        <Button onClick={handle_close} variant='outlined'>{"Cancel"}</Button>
        <LoadingButton variant='outlined' loading={props.products_colors_dialog_state.isLoading} disabled={false} onClick={handle_product_color}>{props.products_colors_dialog_state.type}</LoadingButton>
        </DialogActions>
      </Dialog>

    </div>

  );
}


export default React.memo(ProductsColorsDialog);